<template>
	<div id="app">
		<router-view :key="$route.fullPath"></router-view>
		<vue-progress-bar></vue-progress-bar>
		<InstallApp />

		<Notifications />
	</div>
</template>

<script>
import gql from "graphql-tag"
import { mapMutations, mapGetters } from "vuex"
import mixins from "@/mixins/mixins"
import listMixins from "@/mixins/listMixins"
import InstallApp from "./components/InstallApp"

import Notifications from "./components/Notifications"

export default {
	name: "App",
	components: { InstallApp, Notifications },
	mixins: [mixins, listMixins],
	beforeMount() {
		this.loadMe()
		this.watchLocation()
	},
	data() {
		return {
			iHaveToCheckOfficePosition: true // checkeo que la ubicacion del dspositivo este cerca de la oficina asignada al usuario, sino pido que la cambie.
		}
	},
	computed: {
		...mapGetters(["isAuthenticated", "loggedUser"])
	},
	methods: {
		...mapMutations(["logout", "updateLoggedUser", "savePosition"]),

		loadMe() {
			if (this.isAuthenticated) {
				this.$apollo
					.query({
						query: gql`
							query {
								userLogged {
									id
									name
									lastname
									email
									account {
										id
									}
								}
							}
						`,
						fetchPolicy: "no-cache"
					})
					.then((data) => {
						this.updateLoggedUser(data.data.userLogged)
					})
					.catch(() => {
						this.$router.push("/logout")
					})
			} else {
				this.$router.push("/logout")
			}
		},

		watchLocation() {
			if (this.isAuthenticated) {
				this.$watchLocation({ enableHighAccuracy: true, timeout: 5000 })
					.then((coordinates) => {
						this.savePosition({
							lat: coordinates.lat,
							lng: coordinates.lng
						})
					})
					.catch((err) => {
						console.log(err)
						// this.$toast.error('Debe aceptar los permisos de ubicación')
					})
			}
		}
	}
}
</script>
